import { render, staticRenderFns } from "./BannerManage.vue?vue&type=template&id=af3262aa&scoped=true"
import script from "./BannerManage.vue?vue&type=script&lang=js"
export * from "./BannerManage.vue?vue&type=script&lang=js"
import style0 from "./BannerManage.vue?vue&type=style&index=0&id=af3262aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af3262aa",
  null
  
)

export default component.exports